import { CheckCircleOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Button, message } from 'admin-web-ui'
import gql from 'graphql-tag'
import React, { useCallback } from 'react'

export const MUTATION = gql`
  mutation resendTemporaryPassword($emailAddress: String!) {
    resendTemporaryPassword(emailAddress: $emailAddress)
  }
`

interface Props {
  emailAddress: string
}

export const ResendInvitationButton: React.FC<Props> = (props) => {
  const [resendTemporaryPassword, resendTemporaryPasswordStatus] = useMutation(
    MUTATION,
    {
      onCompleted: () =>
        message.success(
          `Invitation was successfully resent to ${props.emailAddress}`,
        ),
      onError: () =>
        message.error(
          `An error occurred re-sending invitation to ${props.emailAddress}`,
        ),
    },
  )

  const handleResendInvitation = useCallback(() => {
    resendTemporaryPassword({
      variables: { emailAddress: props.emailAddress },
    })
  }, [resendTemporaryPassword, props.emailAddress])

  return (
    <Button
      loading={resendTemporaryPasswordStatus.loading}
      onClick={handleResendInvitation}
      size="small"
    >
      {resendTemporaryPasswordStatus.data && (
        <>
          <CheckCircleOutlined />{' '}
        </>
      )}
      Resend invitation
    </Button>
  )
}
